var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("div", { staticClass: "open-native-wrap" }, [
        _c("div", {
          staticClass: "close",
          on: {
            click: function ($event) {
              _vm.show = false
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "logo" }),
        _vm._v(" "),
        _c("div", { staticClass: "des" }, [_vm._v("更多精彩打开APP查看")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "open-btn" },
          [
            _c(
              "WXLaunchBtn",
              {
                attrs: { schema: _vm.schema },
                on: {
                  error: _vm.handleWxLunchBtnError,
                  wxClick: _vm.handleWxClick,
                },
              },
              [
                _c("template", { slot: "default" }, [
                  _c(
                    "div",
                    {
                      staticClass: "open-btn-in",
                      attrs: { id: "openBtn" },
                      on: { click: _vm.callNativeAmap },
                    },
                    [_vm._v("打开")]
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }